import { MapperFactory } from '@products/utils/mappers/mapper-factory';
import { Mapper, MapperParams } from '@products/utils/mappers/type.mapper';
import {
  GermanCalculatorResultDTO,
  GermanCalculatorResultDurationDTO,
  GermanCalculatorResultPeriodDTO,
  GermanCalculatorResultSummaryDTO,
} from '../dto/german-calculator.dto.types';
import {
  GermanCalculatorResult,
  GermanCalculatorResultDuration,
  GermanCalculatorResultPeriod,
  GermanCalculatorResultSummary,
} from '../model/german-calculator';

export class GermanCalculatorMapper extends Mapper<GermanCalculatorResult> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(
    germanCalculatorResultDTO: GermanCalculatorResultDTO
  ): GermanCalculatorResult {
    return {
      status: germanCalculatorResultDTO.Status,
      periods: this.createMapper(GermanCalculatorResultPeriodsMapper).toDomain(
        germanCalculatorResultDTO.Periods
      ),
      summary: this.createMapper(GermanCalculatorResultSummaryMapper).toDomain(
        germanCalculatorResultDTO.Summary
      ),
    };
  }
}

export class GermanCalculatorResultPeriodsMapper extends Mapper<
  GermanCalculatorResultPeriod[]
> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(
    germanCalculatorResultPeriodsDTO: GermanCalculatorResultPeriodDTO[]
  ): GermanCalculatorResultPeriod[] {
    const germanCalculatorResultPeriods: GermanCalculatorResultPeriod[] = [];

    germanCalculatorResultPeriodsDTO?.forEach(
      (germanCalculatorResultPeriodDTO: GermanCalculatorResultPeriodDTO) => {
        const germanCalculatorResultPeriod: GermanCalculatorResultPeriod = this.createMapper(
          GermanCalculatorResultPeriodMapper
        ).toDomain(germanCalculatorResultPeriodDTO);

        if (germanCalculatorResultPeriod) {
          germanCalculatorResultPeriods.push(germanCalculatorResultPeriod);
        }
      }
    );

    return germanCalculatorResultPeriods;
  }
}

export class GermanCalculatorResultPeriodMapper extends Mapper<GermanCalculatorResultPeriod> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(
    germanCalculatorResultPeriodDTO: GermanCalculatorResultPeriodDTO
  ): GermanCalculatorResultPeriod {
    return {
      elapsedTime: this.createMapper(
        GermanCalculatorResultDurationMapper
      ).toDomain(germanCalculatorResultPeriodDTO.ElapsedTime),
      finalBalance: germanCalculatorResultPeriodDTO.FinalBalance,
      initialBalance: germanCalculatorResultPeriodDTO.InitialBalance,
      interestIncome: germanCalculatorResultPeriodDTO.InterestIncome,
      cumulativeInterestIncome:
        germanCalculatorResultPeriodDTO.CumulativeInterestIncome,
      deposits: germanCalculatorResultPeriodDTO.Deposts,
      withdrawls: germanCalculatorResultPeriodDTO.Withdrawals,
    };
  }
}

export class GermanCalculatorResultSummaryMapper extends Mapper<GermanCalculatorResultSummary> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(
    germanCalculatorResultSummaryDTO: GermanCalculatorResultSummaryDTO
  ): GermanCalculatorResultSummary {
    return {
      finalBalance: germanCalculatorResultSummaryDTO.FinalBalance,
      initialBalance: germanCalculatorResultSummaryDTO.InitialBalance,
      interestIncome: germanCalculatorResultSummaryDTO.InterestIncome,
      interestRate: germanCalculatorResultSummaryDTO.InterestRate,
      investmentPeriod: this.createMapper(
        GermanCalculatorResultDurationMapper
      ).toDomain(germanCalculatorResultSummaryDTO.InvestmentPeriod),
      installmentAmount: germanCalculatorResultSummaryDTO.InstalmentAmount,
      totalDeposits: germanCalculatorResultSummaryDTO.TotalDeposits,
      withdrawlAmount: germanCalculatorResultSummaryDTO.WithdrawalAmount,
    };
  }
}

export class GermanCalculatorResultDurationMapper extends Mapper<GermanCalculatorResultDuration> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(
    germanCalculatorResultDurationDTO: GermanCalculatorResultDurationDTO
  ): GermanCalculatorResultDuration {
    return {
      days: germanCalculatorResultDurationDTO.Days,
      years: germanCalculatorResultDurationDTO.Years,
    };
  }
}
